<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent:0px;">I am indebted to the constables, sergeants, and inspectors and especially the Custody Sergeants of South Yorkshire Police. Between us, for twenty-seven years we did a difficult and thankless job without undue incident or complaint. Apart from when I was tired out or there was fog on the motorway, I enjoyed every minute.</p><br/>
<p style="text-indent:0px;">Thanks to the makers of Red Bull who probably prevented my premature demise by falling asleep on the M18 after repeated nights on call.</p><br/>
<p style="text-indent:0px;">I thank my late wife, Susan, for putting up with the arduous long hours and the nocturnal disturbances and for standing with me when certain people tried to destroy our relationship.</p><br/>
<p style="text-indent:0px;">Thanks must go to my chemistry master, Sandy Powell, who pushed me, kicking and screaming, into a medical career and to Professor Francis James Patrick O’Gorman F.R.C.S., M.R.C.O.G., M.R.C.P. (FO’G.), who taught me to believe in myself, to work hard and to laugh. Thanks to Prof Alan Usher, the doyen of English Forensic Pathologists, for his encouragement and humour.</p><br/>
<p style="text-indent:0px;">And lastly to my present wife, Tanya, who has brought some happiness to a tortured soul.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?5bf9016c